
(function($) {

    $('div.woocommerce').on('change', '.qty', function(){

    jQuery("[name='update_cart']").trigger("click");

    });

    $( document ).ajaxSuccess(function( event, xhr, settings ) {

        try {
            var obj = JSON.parse(xhr.responseText);

            if (obj.fragments['div.widget_shopping_cart_content'] != undefined) {


                var data2 = {
                    'action': 'update_cart_in_nav_item',
                    'dataType': 'json'
                };

                $.get(eventsFilter.ajaxurl, data2, function (response) {
                    $('#cart_amount').html(response);

                    if (response <= 0) {
                        $('#basket_wrapper').css('display', 'none');
                    }
                });

                var data = {
                    'action': 'update_cart_in_nav',
                    'dataType': 'json'
                };

                $.get(eventsFilter.ajaxurl, data, function (response) {
                    $('#display_basket_nav').html(response);
                });

            }
        } catch(e) {

        }
    });



})(jQuery);